module.exports = __webpack_public_path__ + "static/media/neko-young-result-1.d06f022c.png";